import { configureStore } from '@reduxjs/toolkit';
import { errorLoggingMiddleware } from './middleware/errorLoggingMiddleware';
import globalErrorReducer from './slices/globalErrorSlice';
import informationsReducer from './slices/informationsSlice';
import masterReducer from './slices/masterSlice';
import reportDownloadReducer from './slices/reportDownloadSlice';
import sessionReducer from './slices/sessionSlice';
import templateReducer from './slices/templateSlice';
import useMediaFormReducer from './slices/useMediaFormSlice';
import useMediaReducer from './slices/useMediaSlice';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    master: masterReducer,
    useMedia: useMediaReducer,
    useMediaForm: useMediaFormReducer,
    informations: informationsReducer,
    globalError: globalErrorReducer,
    reportDownload: reportDownloadReducer,
    template: templateReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(errorLoggingMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
